import { load } from 'exifreader'
import { FileTarget, getFileTargetFromName } from '~/utilities/fileTarget'

export const getExifData = async (file: File): Promise<ExifReader.Tags> => {
    // Renaming the file because ExifReader gives and error on weird names
    const newBlob = new Blob([file], { type: file.type })
    const newFile = new File([newBlob], 'normalname', {
        type: file.type,
    })
    const exif = await load(newFile)

    return exif
}

export const getMtime = async (file: File): Promise<number | undefined> => {
    const isImage = getFileTargetFromName(file.name) === FileTarget.Pictures
    const nowInSeconds = Math.floor((file.lastModified || Date.now()) / 1000)

    if (!isImage) {
        return nowInSeconds
    }
    try {
        const exif = await getExifData(file)
        // These are the exif tags the backend is setting the ctime from.
        // If they are present we leave mtime undefined and the backend will set it from there.
        // If not present they will use the mtime we send.
        const mtime =
            exif.DateTimeOriginal || exif.DateTimeDigitized || exif.DateTime
                ? undefined
                : nowInSeconds
        return mtime
    } catch {
        // Return undefined if we can't get the exif data
        return undefined
    }
}

export const canReadFileContent = (file: File | Blob): Promise<boolean> =>
    new Promise((resolve) => {
        const f = new FileReader()
        f.onload = () => resolve(true)
        f.onerror = () => resolve(false)
        f.readAsBinaryString(file.slice(0, 64))
    })
